// Registra il service worker che rende il portale installabile sul telefono.
// Se fallisce non succede nulla: il portale resta un sito normale.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch(() => {});
  });
}
